import {
  ISaveScoreOrder,
  IScore,
  IScoreCreate,
  IScoreSearchParams,
  IScoreUpdate,
} from '../../resource/score/score.types';
import { IApiRequestConfig } from '../api.types';

export const getScoreBoardApi = (searchParams: IScoreSearchParams): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'scoreBoard',
  uri: 'json',
  action: 'getScoreBoard',
  method: 'get',
  params: searchParams,
});

export const createScoreApi = (score: IScoreCreate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createScoreApi',
  uri: 'json',
  action: 'saveScore',
  method: 'post',
  data: score,
});

export const updateScoreApi = (score: IScoreUpdate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateScoreApi',
  uri: 'json',
  action: 'saveScore',
  method: 'post',
  data: score,
});

export const updateScoresBulkApi = (payload: {
  scoreIds: IScore['id'][];
  userId?: string;
}): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateScoresBulkApi',
  uri: 'json',
  action: 'scores',
  method: 'patch',
  data: payload,
  v2: true,
});

export const deleteScoreApi = (scoreId: IScore['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteScoreApi',
  uri: 'json',
  action: `scores/${scoreId}`,
  method: 'delete',
  v2: true,
});

export const saveScoreOrderApi = (scoreIds: ISaveScoreOrder): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'saveScoreOrderApi',
  uri: 'json',
  action: 'saveScoreOrder',
  method: 'post',
  data: scoreIds,
});
